export class Auth {
  isRefreshingToken = false

  isLogged() {
    return this.store
      ? this.store.getters['auth/loggedIn']
      : false
  }
}

const instance = new Auth()

function authHelper(app, { router, store }) {
  if (!store || !router) {
    throw new Error('Missing required params')
  }

  instance.store = store
  instance.router = router

  router.beforeEach(async (to) => {
    const requiresAuth = to.matched.some((route) => {
      return (
        route.meta.middleware &&
        route.meta.middleware.includes('auth')
      )
    })

    if (!requiresAuth) {
      return true
    }

    if (store.getters['auth/loggedIn']) {
      return true
    }

    if (await store.dispatch('auth/trySilentLogin')) {
      return true
    }

    return {
      name: 'Login'
    }
  })

  app.config.globalProperties.$auth = instance
}

export default authHelper